import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Mail, Building2, Clock } from "lucide-react";

export default function Contact() {
  return (
    <main className="bg-white" data-testid="contact-page">
      <Helmet>
        <title>Contact Us | VoiceRanker.ai</title>
        <meta name="description" content="Get in touch with the VoiceRanker.ai team — questions about our reviews, corrections, partnerships or privacy requests." />
        <link rel="canonical" href="https://voiceranker.ai/contact" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-3">Get in touch</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-[#0F172A]" data-testid="contact-title">Contact Us</h1>
        <p className="mt-6 text-base md:text-lg text-slate-700 leading-relaxed">
          Questions about our editorial methodology, a correction to a review, partnership enquiries, or a privacy request? We read every message and typically respond within 2 business days.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
          <div className="border border-slate-200 rounded-lg p-6">
            <Mail className="w-6 h-6 text-[#5A31F4]" />
            <h3 className="mt-4 font-heading font-bold text-[#0F172A]">Email</h3>
            <a href="mailto:support@voiceranker.ai" data-testid="contact-email-link" className="mt-2 block text-sm text-[#1A56DB] font-semibold hover:underline">
              support@voiceranker.ai
            </a>
          </div>
          <div className="border border-slate-200 rounded-lg p-6">
            <Building2 className="w-6 h-6 text-[#5A31F4]" />
            <h3 className="mt-4 font-heading font-bold text-[#0F172A]">Company</h3>
            <p className="mt-2 text-sm text-slate-600">Digital Media Strategies Ltd<br />Operator of VoiceRanker.ai</p>
          </div>
          <div className="border border-slate-200 rounded-lg p-6">
            <Clock className="w-6 h-6 text-[#5A31F4]" />
            <h3 className="mt-4 font-heading font-bold text-[#0F172A]">Response time</h3>
            <p className="mt-2 text-sm text-slate-600">Within 2 business days, Monday–Friday.</p>
          </div>
        </div>

        <div className="mt-12 bg-[#F8FAFC] border border-slate-200 rounded-lg p-8">
          <h2 className="font-heading text-xl font-bold text-[#0F172A]">Before you write</h2>
          <ul className="mt-4 space-y-2 text-sm text-slate-600 list-disc pl-5">
            <li>Vendor pricing or feature changed? Include a link to the vendor page and we'll verify and update the review.</li>
            <li>Privacy or data requests are handled per our <Link to="/privacy-policy" className="text-[#1A56DB] font-semibold">Privacy Policy</Link>.</li>
            <li>We do not sell rankings or accept paid placements — see our <Link to="/disclaimer" className="text-[#1A56DB] font-semibold">Disclaimer of Use</Link>.</li>
          </ul>
        </div>
      </div>
    </main>
  );
}
